import { render, staticRenderFns } from "./compras.vue?vue&type=template&id=56a626a0&"
import script from "./compras.vue?vue&type=script&lang=js&"
export * from "./compras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports